import React from 'react';

import * as S from './styles';
import { IProps } from './types';
import { PendingReviewItem } from '@organisms';
import { meForAccountPage } from '@components/pages/AccountPage/__generated__/meForAccountPage';
import { useQuery } from '@apollo/react-hooks';
import { ME_FOR_ACCOUNT_PAGE } from '@components/pages/AccountPage/queries';
import { Loading } from '@atoms';
import { getDBIdFromGraphqlId } from '@utils';
import { useAlert } from 'react-alert';

const PendingReviewPage: React.FC<IProps> = ({}: // destructure props here if needed
IProps) => {
  const { data, loading } = useQuery<meForAccountPage>(ME_FOR_ACCOUNT_PAGE);

  // const reviewRewardAmount = Number(sessionStorage.getItem('reviewRewardAmount'));
  // const reviewRewardAmountWithImage = Number(sessionStorage.getItem('reviewRewardAmountWithImage'));

  if (loading) {
    return <Loading />;
  }

  return (
    data && (
      <>
        <S.Wrapper>
          <S.HeaderWrapper>
            <S.Header>My Pending Reviews</S.Header>
            {/*{(reviewRewardAmount > 0 || reviewRewardAmountWithImage > 0) && (*/}
            {/*  <S.SubHeader>*/}
            {/*    {reviewRewardAmount > 0 && `✏️ ${reviewRewardAmount} Point `}*/}
            {/*    {reviewRewardAmountWithImage > 0 && `📷 ${reviewRewardAmountWithImage} Points`}*/}
            {/*  </S.SubHeader>*/}
            {/*)}*/}
          </S.HeaderWrapper>
        </S.Wrapper>

        <S.PendingReviewWrapper>
          {data?.me?.notReviewedProducts
            ?.filter((p, idx) => {
              const dbId = getDBIdFromGraphqlId(p.productType.id, 'ProductType');
              return dbId in [1, 2, 4];
            })
            .map((product, idx) => {
              return <PendingReviewItem key={idx} product={product} />;
            })}
        </S.PendingReviewWrapper>
      </>
    )
  );
};

export { PendingReviewPage };
